
import React from 'react';
import { useNavigate } from 'react-router-dom';
import FirstBusinessForm from '@/components/business/firstBusiness/FirstBusinessForm';
import TestimonialSection from '@/components/business/firstBusiness/TestimonialSection';
import { NavBarLogo } from '@/components/navbar/NavBarLogo';
import { useIsMobile } from '@/hooks/use-mobile';
import { BusinessFormProvider } from '@/context/BusinessFormContext';

const CreateFirstBusiness: React.FC = () => {
  const navigate = useNavigate();
  const isMobile = useIsMobile();

  // This handleGoBack function should only be used when explicitly clicking
  // the back button, not on every page load
  const handleGoBack = () => {
    // Can redirect to login instead of portfolios since portfolios is protected
    navigate('/login');
  };

  const handleBusinessCreated = (businessId: string) => {
    console.log("handleBusinessCreated: Function called with businessId:", businessId);
    const navigationPath = `/business/${businessId}/gocampaign`;
    console.log("handleBusinessCreated: Navigating to path:", navigationPath);
    // Navigate to the GoCampaign page for the new business
    navigate(navigationPath);
  };

  return (
    <BusinessFormProvider>
      <div className="flex flex-col md:flex-row min-h-screen">
        {/* Form Section (Left/Top half) */}
        <div className="w-full md:w-1/2 p-4 md:p-8 lg:p-12 overflow-y-auto">
          <div className="max-w-xl mx-auto">
            {/* Sticky mobile header */}
            {isMobile && (
              <div className="sticky top-0 bg-white z-50 py-3 flex items-center justify-between">
                <NavBarLogo />
                {/* We'll let FirstBusinessForm control this button's behavior */}
                <FirstBusinessForm.BackButton onGoHome={handleGoBack} />
              </div>
            )}
            
            {/* Desktop-only header */}
            {!isMobile && (
              <div className="bg-white z-10 pb-1 mb-1 md:pb-6 md:mb-6">
                <div className="flex items-center justify-between">
                  <NavBarLogo />
                  {/* We'll let FirstBusinessForm control this button's behavior */}
                  <FirstBusinessForm.BackButton onGoHome={handleGoBack} />
                </div>
                
                <h1 className="text-3xl font-bold mt-8 mb-3">Create Your First Business</h1>
                <p className="text-gray-600">
                  Get started by filling out your business information below.
                </p>
              </div>
            )}
            
            {/* Mobile-only header text - Adjusted padding to match search field */}
            {isMobile && (
              <div className="bg-white z-10 pb-1 mb-4 px-2.5 pr-8">              
                <h1 className="text-3xl font-bold mt-2 mb-3">Create Your First Business</h1>
                <p className="text-gray-600">
                  Get started by filling out your business information below.
                </p>
              </div>
            )}
            
            <FirstBusinessForm 
              onComplete={handleBusinessCreated}
              onGoBack={handleGoBack}
            />
          </div>
        </div>
        
        {/* Testimonial Section (Right/Bottom half) */}
        <TestimonialSection />
      </div>
    </BusinessFormProvider>
  );
};

export default CreateFirstBusiness;
